import { IColuna } from 'app/types/IColuna'
import React from 'react'

export type ThProps = {
    nomeColuna: string
    colunas?:IColuna[]
} & React.PropsWithChildren<any>

export const Th = (props: ThProps) => {
    return <>
        {props.colunas.find(c => c.Nome)?.Selecionada == true && <th>
            {props.children}
        </th>}
    </>
}